import React from 'react';
import { I18n } from '@fiverr-private/fiverr_context';
import PriceSummaryPopover, { SOURCE_COMPONENT } from '../../PriceSummaryPopover';

import './style.scss';

const ServiceFeeLabel = ({ packageId }) => (
    <PriceSummaryPopover packageId={packageId} sourceComponent={SOURCE_COMPONENT.STICKY_SUMMARY}>
        <span className="service-fee-label co-text-darker t-a-right"><I18n k="gig_page_perseus.packages_tabs.service_fee_label"/></span>
    </PriceSummaryPopover>
);

export default ServiceFeeLabel;
